<template>
  <b-modal id="view-qr" hide-footer title="QR Code">
    <div class="text-center">
      <div v-if="getQrCode">
        <QRcode :value="getQrCode" :size="200" level="H" />
      </div>
      <div v-else>No QR Code</div>
    </div>
  </b-modal>
</template>

<script>
import QRcode from "qrcode.vue";
export default {
  components: {
    QRcode,
  },
  computed: {
    getQrCode() {
      const data = this.$store.getters["location/qr"];
      return data || "";
    },
  },
};
</script>
